module.exports = __webpack_public_path__ + "static/media/modifyDesktop.a7664078.svg";